import { frontEndRedirect, frontEndTabOpen } from "@smartrr/shared/utils/locationUtils";

export function vendorPortalFrontendRedirect(fullRedirectUrl: string, openInNewTab = false): void {
  if (openInNewTab) {
    frontEndTabOpen(fullRedirectUrl);
  } else {
    frontEndRedirect(fullRedirectUrl);
  }
}
